module.exports = __webpack_public_path__ + "static/img/2019-05-08.36f93cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/press/2019-05-08.png
// module id = XK8l
// module chunks = 1